"use client"

import { useEffect } from "react"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // sendBeacon direct ici car logError peut ne pas etre charge si le root layout a crashe
    try {
      const body = JSON.stringify({
        level: "error",
        source: "global-error-boundary",
        message: error.message || "Root layout crash",
        stack: error.stack,
        url: window.location.pathname,
        userAgent: navigator.userAgent,
        extra: error.digest ? { digest: error.digest } : undefined,
      })
      navigator.sendBeacon("/api/log", new Blob([body], { type: "application/json" }))
    } catch {
      // Silencieux
    }
  }, [error])

  return (
    <html>
      <body style={{ fontFamily: "system-ui, sans-serif", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", margin: 0, background: "#f4f6f9" }}>
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <h2 style={{ fontSize: "1.25rem", fontWeight: 600, color: "#111" }}>Erreur critique</h2>
          <p style={{ fontSize: "0.875rem", color: "#666", marginTop: "0.5rem" }}>
            L'application a rencontre un probleme. L'erreur a ete signalée.
          </p>
          {error.digest && (
            <p style={{ fontSize: "0.75rem", color: "#999", marginTop: "0.5rem", fontFamily: "monospace" }}>
              Ref: {error.digest}
            </p>
          )}
          <div style={{ marginTop: "1.5rem", display: "flex", gap: "0.75rem", justifyContent: "center" }}>
            <button
              onClick={reset}
              style={{ padding: "0.5rem 1rem", fontSize: "0.875rem", borderRadius: "0.5rem", border: "1px solid #ddd", background: "#fff", cursor: "pointer" }}
            >
              Reessayer
            </button>
            <button
              onClick={() => (window.location.href = "/")}
              style={{ padding: "0.5rem 1rem", fontSize: "0.875rem", borderRadius: "0.5rem", border: "none", background: "#1B2A4A", color: "#fff", cursor: "pointer" }}
            >
              Accueil
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
